export default function HowItWorks() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-3/5 w-full">
            <span className="inline-flex items-center gap-2 text-secondary-500 font-semibold text-sm tracking-widest uppercase mb-4 whitespace-nowrap">
              <i className="ri-circle-fill text-[6px]"></i>
              Como Funciona
            </span>
            <blockquote className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-900 leading-relaxed italic">
              &ldquo;Milhares de usuários no Brasil confiam na nossa planilha para compras internacionais seguras e rápidas.&rdquo;
            </blockquote>
            <div className="mt-6 flex items-center gap-3">
              <span className="font-semibold text-foreground-900 text-sm">CSSBuy Brasil</span>
              <span className="flex items-center gap-0.5 text-accent-500">
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
                <i className="ri-star-fill text-xs"></i>
              </span>
              <span className="text-foreground-400 text-xs">Comunidade verificada</span>
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6">
              {[
                { step: "01", title: "Acesse a Planilha", desc: "Navegue pelas categorias organizadas e encontre os produtos que deseja." },
                { step: "02", title: "Copie o Link", desc: "Copie o link do produto e cole no CSSBuy para adicionar ao carrinho." },
                { step: "03", title: "Receba no Brasil", desc: "Escolha o melhor método de envio e receba seus produtos com segurança." },
              ].map((item) => (
                <div key={item.step} className="bg-background-100 rounded-2xl p-6">
                  <span className="text-4xl font-heading font-bold text-foreground-200">{item.step}</span>
                  <h4 className="mt-3 font-heading text-lg font-semibold text-foreground-900">{item.title}</h4>
                  <p className="mt-2 text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-2/5 w-full">
            <div className="rounded-3xl overflow-hidden h-[320px] md:h-[460px]">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20fashion%20stylist%20organizing%20curated%20product%20collection%20on%20minimalist%20workspace%20warm%20neutral%20background%20clean%20bright%20natural%20window%20lighting%20editorial%20portrait%20style%20cream%20and%20beige%20tones%20modern%20aesthetic%20hands%20arranging%20sneakers%20and%20accessories%20on%20wooden%20desk&width=600&height=800&seq=how-v2-img&orientation=portrait"
                alt="CSSBuy Brasil comunidade"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}